import { render } from "./UsingTheSite.vue?vue&type=template&id=1d54f462&ts=true"
import script from "./UsingTheSite.vue?vue&type=script&lang=ts"
export * from "./UsingTheSite.vue?vue&type=script&lang=ts"

import exportComponent from "/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__